import { type PropsWithChildren } from 'react'

import SignInRoute from '@/routes/Signin/SignInRoute'
import { useUser } from '@state/user'

import { NotAuthenticatedError } from '../utils/errors'

import GuardLoadingScreen from './GuardLoadingScreen'

function UserGuard({ children }: PropsWithChildren) {
  const { isError, isLoading, error } = useUser()

  if (isLoading) return <GuardLoadingScreen i18nKey="common.loadingSignInClients" />

  if (error instanceof NotAuthenticatedError && isError) return <SignInRoute />

  return children
}

export default UserGuard